<script setup lang="ts">
import { useColorClass } from '@/composables/getColorClass';
const emit = defineEmits(['media-selected']);

defineProps({
  count: {
    type: Number,
    required: true,
  },
  icon: {
    type: Array,
    required: true,
  },
  color: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div
    class="relative shadow-small w-[192px] h-[90px] border border-2 border-neutral-300 bg-neutral-0 rounded-[16px] mr-6 flex items-center justify-center"
    @click="emit('media-selected')"
  >
    <fa-icon :icon="icon" class="text-4xl" />
    <div
      class="absolute border-2 border-white flex items-center justify-center rounded-full right-[-10px] top-[-10px] px-2 h-[34px]"
      :class="[useColorClass(color).bg, { 'w-[34px] px-0': count < 10 }]"
    >
      <span class="text-neutral-0 h600">{{ count <= 99 ? count : '+99' }}</span>
    </div>
  </div>
</template>
